import MovementServicesContainer from "@features/movement-services/MovementServicesContainer.tsx";
import MovementServicesPage from "@pages/movement-services/MovementServicesPage.tsx";
import { paths } from "@utils/navigation";
import { type AppRoute } from "../types";

export const getMovementServicesRoutes = (): AppRoute => ({
  path: paths.movementServices.index,
  protected: true,
  element: <MovementServicesPage />,
  requiredPermissions: ["hasVesselCallAccess"],
  children: [{ index: true, element: <MovementServicesContainer /> }],
});
